var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcicles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.427 37.868L423.915 505.532C422.29 514.156 409.913 514.156 408.288 505.532L341.529 141.724L295.772 314.192C293.397 321.816 282.771 321.816 280.395 314.192L246.266 180.842L199.759 377.681C197.884 386.054 186.133 386.054 184.257 377.681L140.001 190.465L103.621 314.567C101.246 321.691 90.995 321.691 88.494 314.567L1.358 41.242C-4.768 20.746 10.609 0 31.987 0H480.047C500.05 0 515.177 18.247 511.427 37.868Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcicles);
export default __webpack_public_path__ + "static/media/icicles.f751c84ed7d70289a6a772faba87afb1.svg";
export { ForwardRef as ReactComponent };